import React, { useEffect, useState } from "react";
import Menu from './menu';
import Thread from './thread';
import Addbtn from './addBtn';
// import { info } from './info.js';
import axios from 'axios';

type Info = {
    id: number;
    date: string;
    title: string;
    article: string;
    note: string;
    flag: number;
};

const App: React.FC = () => {
    const [information, setInformation] = useState<Info[]>([]);
    const [articleLength, setArticleLength] = useState<number>(4);

    const fetchDiaries = async () => {
        try {
            const response = await axios.post("/portfolio/api/getdiary.php");
            setInformation(response.data);
        } catch (error) {
          console.error("Error fetching diaries:", error);
        }
      };
    
    useEffect(() => {
        fetchDiaries();
    }, []);

    const postDiary = async (params: FormData) => {
        try {
        const response = await axios.post(
        "https://sksk.works/portfolio/api/postdiary.php",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        console.log("POST Response:", response.data);
        fetchDiaries(); 
        } catch (error) {
        console.error("Error posting diary:", error);
        }
    };

  return (
    <div className="">
        <div className="d-lg-flex">
            <div className="menu">
                <Menu />
            </div>
            <div className="thread w-100">
                <Addbtn postDiary={postDiary} />
                <Thread information={information} articleLength={articleLength}/>
            </div>
        </div>
    </div>
  );
};

export default App;
